export default __webpack_public_path__ + "static/media/Group 1676.7d43d982.svg";